module.exports = __webpack_public_path__ + "img/tab04.c8dff156.png";